import React, { useState, useRef } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import * as XLSX from "xlsx";
import { db } from "../../../../firebase";
import {
  doc,
  updateDoc,
  getDoc,
  deleteDoc,
  Timestamp,
} from "firebase/firestore";

const ToolDashUpdateDevolutions = (props) => {
  const fileInputRef = useRef(null);
  const [mensajeLoadDataEstatusID, setMensajeLoadDataEstatusID] =
    useState(null);
  const [dataDevolution, setDataDevolution] = useState(null);

  /* ==================== HANDLERS (lógica igual, sin TS) ==================== */

  const handleFileDevolutionDoc = async (e) => {
    console.log("Aqui Archivo devoluciones");

    if (e.target.files && e.target.files.length > 0) {
      props.setAlertMensajes("Seleccionado 1 archivo de devoluciones");
    } else {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const woskbook = XLSX.read(data);

    const worksheet = woskbook.Sheets["DATA"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    //Validar Nombres
    try {
      const lpn = jsonData[0]["LPN"];
      const id = jsonData[0]["SOC"];
      const idDevolution = jsonData[0]["BAJA"];
      const dateDevolution = jsonData[0]["FECHABAJA"];
      const comentDevolution = jsonData[0]["COMENTARIOBAJA"];

      if (lpn && id && idDevolution && dateDevolution && comentDevolution) {
        props.setAlertMensajes("Archivo válido, listo para procesar");
        setDataDevolution(jsonData);
      } else {
        props.setAlertMensajes(
          <div>
            {`Nombres clave requeridos. Revise el documento y ajústelo:
            const lpn = jsonData[0]["LPN"]; 
            const id = jsonData[0]["SOC"];
            const idDevolution = jsonData[0]["BAJA"]; 
            const dateDevolution = jsonData[0]["FECHABAJA"]; 
            const comentDevolution = jsonData[0]["COMENTARIOBAJA"];`}
          </div>
        );
      }
    } catch (error) {
      console.log(error);
      props.setAlertMensajes("No se encuentra la hoja con nombre HOJA: DATA");
    }

    if (jsonData && jsonData.length > 0) {
      for (let n = 0; n < jsonData.length; n++) {
        const element = jsonData[n];
        const companyIdOrder = "F" + element.SOC.toString();
        const orderRef = doc(
          db,
          process.env.REACT_APP_COL_ORDERS,
          companyIdOrder
        );
        const docSnapshot = await getDoc(orderRef);
        if (docSnapshot.exists()) {
          console.log("existe en tabla orders express");

          await updateDoc(orderRef, {
            idDevolution: element.idDevolution ? element.idDevolution : "",
            dateDevolution: element.dateDevolution
              ? element.dateDevolution
              : "",
            statusComemmty: element.comentDevolution
              ? element.comentDevolution
              : "",
            status: "Devolución",
            int_bicciStatus: "Devolución",
            int_falabella_status: "Devolución",
            int_falabella_status_descriptor: "Devolución",
          });
        } else {
          // Lógica comentada en tu código original
        }
      }
    }
  };

  const handleFileasiceCommets = async (e) => {
    console.log("Aqui Archivo devoluciones");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo de comentarios");

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    const worksheet = workbook.Sheets["DATA"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      if (jsonData && jsonData.length > 0) {
        for (let n = 0; n < jsonData.length; n++) {
          const element = jsonData[n];
          const companyIdOrder = "F" + element.BICCIID.toString();
          const newComent = element.COMMET;

          const orderRef = doc(
            db,
            process.env.REACT_APP_COL_USERS_ORDERS,
            companyIdOrder
          );
          const docSnapshot = await getDoc(orderRef);

          if (docSnapshot.exists()) {
            console.log("ACTUALIZANDO COMENTARIO DE ADMIN");
            const currentComments = docSnapshot.data().observationAdmin || [];
            currentComments.push(newComent);
            await updateDoc(orderRef, { observationAdmin: currentComments });
            console.log("Comentarios actualizados con éxito.");
          } else {
            console.log("NO SE ENCONTRO EL ID:", element.BICCIID);
          }
        }
      }
    } catch (error) {
      console.error("Error al actualizar los comentarios:", error);
    }
  };

  const handleFileCorrection = async (e) => {
    console.log("Aquí Archivo corrección");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo de corrección");

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    const worksheet = workbook.Sheets["DATAORRECTION"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      if (jsonData && jsonData.length > 0) {
        for (let n = 0; n < jsonData.length; n++) {
          const element = jsonData[n];
          const companyIdOrder = element.BICCIID.toString();

          const specificDate = new Date(Date.UTC(2024, 7, 26, 9, 54, 46));
          const updatedAtTimestamp = Timestamp.fromDate(specificDate);
          const orderRef = doc(
            db,
            process.env.REACT_APP_COL_FALABELLA_ORDERS,
            companyIdOrder
          );
          const docSnapshot = await getDoc(orderRef);

          if (docSnapshot.exists()) {
            console.log("ACTUALIZANDO ERROR DE CARGA");

            await updateDoc(orderRef, {
              updatedAt: updatedAtTimestamp,
            });

            console.log("Corrección realizada con éxito.");
          } else {
            console.log("NO SE ENCONTRÓ EL ID:", element.BICCIID);
          }
        }
      }
    } catch (error) {
      console.error("Error al actualizar los DATA:", error);
    }
  };

  const handleFileCorrectionF = async (e) => {
    console.log("Aqui Archivo correcion");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo corrección FALABELLA");

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    const worksheet = workbook.Sheets["DATAORRECTION"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      if (jsonData && jsonData.length > 0) {
        for (let n = 0; n < jsonData.length; n++) {
          const element = jsonData[n];
          const companyIdOrder = element.BICCIID.toString();
          const newBU = element.BU;
          const newDelivery_type = element.TIPODELIVERY;
          const orderRef = doc(
            db,
            process.env.REACT_APP_COL_FALABELLA_ORDERS,
            companyIdOrder
          );
          const docSnapshot = await getDoc(orderRef);

          if (docSnapshot.exists()) {
            console.log("ACTUALIZANDO ERROR DE CARGA");

            await updateDoc(orderRef, {
              bu: newBU,
              delivery_type: newDelivery_type,
            });

            console.log("Correcion realizada con éxito.");
          } else {
            console.log("NO SE ENCONTRO EL ID:", element.BICCIID);
          }
        }
      }
    } catch (error) {
      console.error("Error al actualizar los DATA:", error);
    }
  };

  const handleFileDeleteDocExpress = async (e) => {
    console.log("Aqui Archivo correcion express");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo EXPRESS");

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    const worksheet = workbook.Sheets["DATADELEDXPRESS"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      if (jsonData && jsonData.length > 0) {
        for (let n = 0; n < jsonData.length; n++) {
          const element = jsonData[n];
          const companyIdOrder = element.BICCIID.toString();
          const orderRef = doc(
            db,
            process.env.REACT_APP_COL_ORDERS,
            companyIdOrder
          );
          const docSnapshot = await getDoc(orderRef);

          if (docSnapshot.exists()) {
            await deleteDoc(orderRef);
            console.log(
              "Correcion deleteDoc XPRESS con éxito.",
              element.BICCIID
            );
          } else {
            console.log("NO SE ENCONTRO EL ID XPRESS:", element.BICCIID);
          }
        }
      }
    } catch (error) {
      console.error("Error al actualizar los DATA:", error);
    }
  };

  const handleFileDeleteDocFalabella = async (e) => {
    console.log("Aqui Archivo correcion FALABELLA");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo DELETED FALABELLA");

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    const worksheet = workbook.Sheets["DATADELED"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      if (jsonData && jsonData.length > 0) {
        for (let n = 0; n < jsonData.length; n++) {
          const element = jsonData[n];
          const companyIdOrder = element.BICCIID.toString();
          const orderRef = doc(
            db,
            process.env.REACT_APP_COL_FALABELLA_ORDERS,
            companyIdOrder
          );
          const docSnapshot = await getDoc(orderRef);

          if (docSnapshot.exists()) {
            await deleteDoc(orderRef);
            console.log("Correcion deleteDoc con éxito.", element.BICCIID);
          } else {
            console.log("NO SE ENCONTRO EL ID:", element.BICCIID);
          }
        }
      }
    } catch (error) {
      console.error("Error al actualizar los DATA:", error);
    }
  };

  const handleFileDeleteDocBicci = async (e) => {
    console.log("Aqui Archivo correcion BICCI USERS_ORDERS");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo DELETED BICCI");

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    const worksheet = workbook.Sheets["DATADELED"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      if (jsonData && jsonData.length > 0) {
        for (let n = 0; n < jsonData.length; n++) {
          const element = jsonData[n];
          const companyIdOrder = element.BICCIID.toString();
          const orderRef = doc(
            db,
            process.env.REACT_APP_COL_USERS_ORDERS,
            companyIdOrder
          );
          const docSnapshot = await getDoc(orderRef);

          if (docSnapshot.exists()) {
            await deleteDoc(orderRef);
            console.log("Correcion deleteDoc con éxito.", element.BICCIID);
          } else {
            console.log("NO SE ENCONTRO EL ID:", element.BICCIID);
          }
        }
      }
    } catch (error) {
      console.error("Error al actualizar los DATA:", error);
    }
  };

  const handleFilePiking = async (e) => {
    console.log("Aqui Archivo Picking");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo de picking");

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    const worksheet = workbook.Sheets["PIKINGDOC"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      if (jsonData && jsonData.length > 0) {
        for (let n = 0; n < jsonData.length; n++) {
          const element = jsonData[n];
          const companyIdOrder = element.BICCIID.toString();
          try {
            const orderRef3 = doc(
              db,
              process.env.REACT_APP_COL_USERS_ORDERS,
              companyIdOrder
            );
            await updateDoc(orderRef3, { isPickedUp: true });
            console.log("Actualizado isPickedUp a true para:", companyIdOrder);
          } catch (error) {
            console.log("Error al actualizar el documento:", error);
          }
        }
      }
    } catch (error) {
      console.error("Error al actualizar PIKKING:", error);
    }
  };

  const handleStatusRecusive = async (e) => {
    console.log("Aqui Archivo estados recursivos");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo de estados");

    const file = e.target.files[0];
    const dataBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(dataBuffer);

    const worksheet = workbook.Sheets["DATASTATUS"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      if (jsonData && jsonData.length > 0) {
        for (const element of jsonData) {
          const id = "F" + element.BICCIID.toString();
          const estatus = element.STATUS && element.STATUS.toString();
          if (!estatus) {
            console.log("No se encuentra STATUS");
            return;
          }
          const data = {
            data: {
              orderID: id,
              exceptionID: estatus,
            },
          };

          const config = {
            method: "post",
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_BICCI_API_PRO_SEND_EXCEPTION,
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };

          try {
            await new Promise((resolve) => setTimeout(resolve, 3000));
            const response = await axios.request(config);
            console.log(JSON.stringify(response.data));
            console.log("Actualizo los status:", id);
          } catch (error) {
            console.error("Error al procesar el ID:", id, error);
          }
        }
      }
    } catch (error) {
      console.error("Error al actualizar los status:", error);
    }
  };

  const handleStatusRecusiveReactive = async (e) => {
    console.log("Aqui Archivo estados recursivos REACTIVAR BULTOS");

    if (!e.target.files || e.target.files.length === 0) {
      props.setAlertMensajes("Ningún archivo seleccionado.");
      return;
    }

    props.setAlertMensajes("Seleccionado 1 archivo de reactivación");

    const file = e.target.files[0];
    const dataBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(dataBuffer);

    const worksheet = workbook.Sheets["DATAREPITES"];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);
    console.log(jsonData);
  };

  const handleEmergeciFileCosed = async (e) => {
    console.log("📁 Procesando archivo...");

    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ Ningún archivo seleccionado.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    props.setAlertMensajes(
      "Seleccionado 1 archivo para cierre masivo (emergencia)"
    );

    const file = e.target.files[0];

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);

      const sheetName = "DATATATUSBICCI";
      if (!workbook.Sheets[sheetName]) {
        console.log(`❌ La hoja '${sheetName}' no existe en el archivo.`);
        return;
      }

      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      if (!jsonData || jsonData.length === 0) {
        console.log("❌ La hoja no contiene datos.");
        return;
      }

      let updatedCount = 0;

      for (let n = 0; n < jsonData.length; n++) {
        const element = jsonData[n];
        const companyIdOrder = element.BICCIID && element.BICCIID.toString();
        const statusUpdate = parseInt(element.STATUS);

        if (!companyIdOrder) {
          console.log(`⚠️ Orden sin ID en la fila ${n + 1}`);
          continue;
        }

        const orderRef = doc(
          db,
          process.env.REACT_APP_COL_USERS_ORDERS,
          companyIdOrder
        );
        const docSnapshot = await getDoc(orderRef);

        if (docSnapshot.exists()) {
          await updateDoc(orderRef, { status: statusUpdate });
          updatedCount++;
          console.log(`✔️ Orden actualizada: ${companyIdOrder}`);
        } else {
          console.log(`⚠️ No se encontró el ID: ${companyIdOrder}`);
        }

        if (updatedCount > 0 && updatedCount % 50 === 0) {
          console.log("⏳ Esperando 10 segundos para evitar sobrecarga...");
          await new Promise((resolve) => setTimeout(resolve, 10000));
        }
      }

      console.log(`✅ Total de órdenes actualizadas: ${updatedCount}`);
    } catch (error) {
      console.error("❌ Error al procesar el archivo:", error);
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  /* ==================== UI MUI unificada ==================== */

  const buttonSx = {
    mt: 1,
    width: "100%",
    textTransform: "none",
    fontWeight: 600,
  };

  return (
    <Card sx={{ borderRadius: 2 }}>
      <CardHeader
        title={
          <Typography variant="h6" fontWeight={700}>
            Herramientas masivas de actualización
          </Typography>
        }
        subheader={
          <Typography variant="body2" color="text.secondary">
            Sube archivos Excel para actualizar devoluciones, comentarios,
            estados y correcciones en bloque.
          </Typography>
        }
      />
      <CardContent>
        {props.alertMensajes && (
          <Box mb={2}>
            <Typography variant="body2" color="primary">
              {props.alertMensajes}
            </Typography>
          </Box>
        )}

        {props.LoadDataEstatus && (
          <Box mb={2}>
            <LinearProgress />
          </Box>
        )}

        {mensajeLoadDataEstatusID && (
          <Box mb={2}>
            <Typography variant="body2" color="error">
              {mensajeLoadDataEstatusID}
            </Typography>
          </Box>
        )}

        <Grid container spacing={2}>
          {/* Devoluciones */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Actualizar listado de devoluciones
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Usa hoja <b>DATA</b> con columnas LPN, SOC, BAJA, FECHABAJA,
                  COMENTARIOBAJA.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleFileDevolutionDoc}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Comentarios */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Actualizar comentarios administradores
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Hoja <b>DATA</b> con BICCIID y COMMET.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleFileasiceCommets}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Estados recursivos (API excepciones) */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Actualizar estados recursivos
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Envía excepciones a la API según hoja <b>DATASTATUS</b>.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleStatusRecusive}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Reactivar bultos */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Reactivar bultos
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Usa hoja <b>DATAREPITES</b> (lógica interna a definir).
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleStatusRecusiveReactive}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Cierre masivo emergencia */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Cerrar o reactivar (emergencia)
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Hoja <b>DATATATUSBICCI</b> con BICCIID y DATATATUSBICCI. Se
                  recomienda uso puntual.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    ref={fileInputRef}
                    type="file"
                    onChange={handleEmergeciFileCosed}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Delete EXPRESS */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Corrección órdenes tabla EXPRESS
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Elimina en {process.env.REACT_APP_COL_ORDERS}. Hoja{" "}
                  <b>DATADELEDXPRESS</b>.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleFileDeleteDocExpress}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Delete Falabella */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Corrección órdenes DELETED FALABELLA
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Elimina en {process.env.REACT_APP_COL_FALABELLA_ORDERS}. Hoja{" "}
                  <b>DATADELED</b>.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleFileDeleteDocFalabella}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Delete Bicci USERS_ORDERS */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Corrección órdenes DELETED BICCI
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Elimina en {process.env.REACT_APP_COL_USERS_ORDERS}. Hoja{" "}
                  <b>DATADELED</b>.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleFileDeleteDocBicci}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Picking */}
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Actualizar Picking
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Marca <b>isPickedUp</b> en{" "}
                  {process.env.REACT_APP_COL_USERS_ORDERS}. Hoja{" "}
                  <b>PIKINGDOC</b>.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleFilePiking}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* (Opcional) Corrección Falabella BU / delivery_type */}
          {/*
          <Grid item xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  Corrección tabla FALABELLA (BU / delivery_type)
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Hoja <b>DATAORRECTION</b>.
                </Typography>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<UploadFileIcon />}
                  sx={buttonSx}
                  size="small"
                >
                  Subir archivo
                  <input
                    hidden
                    type="file"
                    onChange={handleFileCorrectionF}
                    accept=".xlsx, .xls"
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>
          */}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ToolDashUpdateDevolutions;
